var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cover-img-container"},_vm._l((_vm.data),function(src,index){return _c('div',{key:index,staticClass:"cover-img"},[_c('img',{directives:[{name:"viewer",rawName:"v-viewer",value:(src),expression:"src"}],attrs:{"src":_vm._f("ossStyle")(src,200),"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }